import { render, staticRenderFns } from "./AxHelp.vue?vue&type=template&id=92f15404&"
import script from "./AxHelp.vue?vue&type=script&lang=ts&"
export * from "./AxHelp.vue?vue&type=script&lang=ts&"
import style0 from "./AxHelp.vue?vue&type=style&index=0&id=92f15404&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports